<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div class="modal fade" id="costumModaltambah" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog modal-fullscreen" style="width: 98vw;height: 98%;">
                <div class="modal-content" style="height: auto;min-width: 95vw; min-height: 98%;">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Data Absen</h4>
                        <button type="button" class="close" aria-label="Close" @click="tutupmodal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 95vw; min-height: 70vh;">
                        <p>
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Jam Masuk <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <input type="datetime-local" class="form-control form-control-sm" :id="'jam_masuk'"
                                    :name="'jam_masuk'" placeholder="Tanggal" v-model="jam_masuk">
                            </div>
                            <div class="col-sm-6">
                                <label>Lokasi Masuk <small class="text-info"> (*wajib
                                        dipilih)</small></label>
                                <v-select :options="lokasi_masuk" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedlokasi_masuk" @update:modelValue="onlokasi_masukChange"
                                    style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                            </div>
                            <div class="col-sm-6">
                                <label>Jam Pulang <small class="text-info"> (*wajib
                                        diisi)</small></label>
                                <input type="datetime-local" class="form-control form-control-sm" :id="'jam_pulang'"
                                    :name="'jam_pulang'" placeholder="Tanggal" v-model="jam_pulang">
                            </div>
                            <div class="col-sm-6">
                                <label>Lokasi Pulang <small class="text-info"> (*wajib
                                        dipilih)</small></label>
                                <v-select :options="lokasi_pulang" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedlokasi_pulang" @update:modelValue="onlokasi_pulangChange"
                                    style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12">&nbsp;</div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white"
                            @click="tambahabsen()"><i class="fas fa-plus"></i> Tambah</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" @click="tutupmodal()"> <i
                                class="far fa-times-circle"></i>
                            Batal</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-4 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-8 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a :href="'/DataAbsensi'">Data Absensi</a></li>
                                <li class="breadcrumb-item"><a :href="'/ProsesDataAbsensi/' + link">Data Absensi</a>
                                </li>
                                <li class="breadcrumb-item active">Pengaturan Detail Absensi</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="col-sm-12 pb-2 text-center">
                                        <label>
                                            Daftar Absensi {{ tulisnama }}, {{ tulisjabatan }} Bulan {{ tulisbulan }} {{
                                                tulistahun }}
                                        </label>
                                    </div>
                                    <div class="col-sm-12 pb-2 text-center">
                                        <button type="button" class="btn btn-success3 btn-sm text-white lebar2"
                                            @click="prosesdata()" data-toggle="tooltip" data-placement="left"
                                            title="Tambah data..">
                                            <i class="fas fa-plus"></i> Tambah
                                        </button>
                                    </div>
                                    <div class="col-sm-11 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>

                                </div>
                                <div class="card-body p-2">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: x-small;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="2">No</th>
                                                    <th style="width: 150px;" rowspan="2">Tanggal</th>
                                                    <th style="width: 300px;" colspan="2">Masuk</th>
                                                    <th style="width: 300px;" colspan="2">Pulang</th>
                                                    <th style="width: 100px;" colspan="2">Jumlah Jam Kerja</th>
                                                    <th style="width: 50px;" rowspan="2">Opsi</th>
                                                </tr>
                                                <tr>
                                                    <th style="width: 200px;">Lokasi</th>
                                                    <th style="width: 100px;">Jam</th>
                                                    <th style="width: 200px;">Lokasi</th>
                                                    <th style="width: 100px;">Jam</th>
                                                    <th style="width: 50px;">Target</th>
                                                    <th style="width: 50px;">Aktual</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">
                                                            {{ urutlist + 1 }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ datalist.tanggal }}
                                                        </td>
                                                        <td class="text-center">
                                                            <select class="form-control form-control-sm custom-select"
                                                                style="font-size: x-small;"
                                                                @change="cekdata('selectmasuk' + datalist.id, datalist.id)"
                                                                :id="'selectmasuk' + datalist.id">
                                                                <template
                                                                    v-for="(datapilihannya, urutpilihannya) in lokasi_masuk"
                                                                    :key="urutpilihannya">
                                                                    <option :value="datapilihannya.tag"
                                                                        :selected="datapilihannya.tag == datalist.id_lokasi_masuk">
                                                                        {{ datapilihannya.label
                                                                        }}
                                                                    </option>
                                                                </template>
                                                            </select>
                                                        </td>
                                                        <td class="text-center">
                                                            <input type="datetime-local"
                                                                class="form-control form-control-sm"
                                                                style="font-size: x-small;" placeholder="Tanggal"
                                                                :id="'jam_masuk_' + datalist.id"
                                                                :name="'jam_masuk_' + datalist.id"
                                                                :value="datalist.jam_masuk"
                                                                @change="cekdata('jam_masuk_' + datalist.id, datalist.id)">
                                                        </td>
                                                        <td class="text-center">
                                                            <select class="form-control form-control-sm custom-select"
                                                                style="font-size: x-small;"
                                                                @change="cekdata('selectpulang' + datalist.id, datalist.id)"
                                                                :id="'selectpulang' + datalist.id">
                                                                <template
                                                                    v-for="(datapilihannya, urutpilihannya) in lokasi_pulang"
                                                                    :key="urutpilihannya">
                                                                    <option :value="datapilihannya.tag"
                                                                        :selected="datapilihannya.tag == datalist.id_lokasi_pulang">
                                                                        {{ datapilihannya.label
                                                                        }}
                                                                    </option>
                                                                </template>
                                                            </select>
                                                        </td>
                                                        <td class="text-center">
                                                            <input type="datetime-local"
                                                                class="form-control form-control-sm"
                                                                style="font-size: x-small;"
                                                                :id="'jam_pulang_' + datalist.id"
                                                                :name="'jam_pulang_' + datalist.id"
                                                                placeholder="Tanggal" :value="datalist.jam_pulang"
                                                                @change="cekdata('jam_pulang_' + datalist.id, datalist.id)">
                                                        </td>
                                                        <td class="text-center">
                                                            {{ G_numFormatKoma(datalist.target_jam_kerja) }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ G_numFormatKoma(datalist.aktual_jam_kerja) }}
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button"
                                                                class="btn btn-danger4 btn-sm text-white"
                                                                @click="hapus(datalist.id)" style="font-size: x-small;"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Hapus data.."><i class="fas fa-trash-alt"></i>
                                                                Hapus</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="5">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Kembali</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            carikata: '',
            id_user: '',
            bulan: '',
            tahun: '',
            link: '',
            tulisnama: '',
            tulisjabatan: '',
            tulisbulan: '',
            tulistahun: '',
            lokasi_masuk: [],
            datalokasi_masuk: [],
            defaultSelectedlokasi_masuk: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi_masuk: '',

            lokasi_pulang: [],
            datalokasi_pulang: [],
            defaultSelectedlokasi_pulang: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi_pulang: '',

            jam_masuk: '',
            jam_pulang: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            levelabsen: process.env.VUE_APP_LEVEL_ABSENSI,
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            validasi: false,

        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        validasidata() {
            if (this.jam_masuk == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Jam Masuk',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            if (this.selectedlokasi_masuk == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Lokasi Masuk',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            if (this.jam_pulang == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Jam Pulang',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            if (this.selectedlokasi_pulang == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Lokasi Pulang',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            this.validasi = true;
            return;
        },
        prosesdata() {
            this.selectedlokasi_masuk = '';
            this.selectedlokasi_pulang = '';
            this.jam_masuk = '';
            this.jam_pulang = '';
            this.defaultSelectedlokasi_masuk = {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            };
            this.defaultSelectedlokasi_pulang = {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            };
            $('#costumModaltambah').modal('show');
        },
        tutupmodal() {
            $('#costumModaltambah').modal('hide');
        },
        tambahabsen() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var fd = new FormData();
            fd.append("id_user", this.id_user);
            fd.append("jam_masuk", this.jam_masuk);
            fd.append("jam_pulang", this.jam_pulang);
            fd.append("lokasi_masuk", this.selectedlokasi_masuk);
            fd.append("lokasi_pulang", this.selectedlokasi_pulang);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("DataAbsensi-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                        $('.swal2-container').css("z-index", '999999');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.reload();
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        cekdata(isinya, id) {
            if (document.getElementById(isinya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Jangan mengisi data kosong',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }

            var isikolom = document.getElementById(isinya).value;
            var kolom = '';

            if (isinya.includes("selectmasuk")) {
                kolom = 'koordinatmasuk';
            }
            if (isinya.includes("jam_masuk")) {
                kolom = 'jam_masuk';
            }
            if (isinya.includes("selectpulang")) {
                kolom = 'koordinatpulang';
            }
            if (isinya.includes("jam_pulang")) {
                kolom = 'jam_pulang';
            }

            var fd = new FormData();
            fd.append("id", id);
            fd.append("kolom", kolom);
            fd.append("isikolom", isikolom);
            fd.append("project_id", this.project_id);

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("DataAbsensi-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                        $('.swal2-container').css("z-index", '999999');
                    }
                    else {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'success',
                            title: 'Data telah diupdate'
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        onlokasi_masukChange(a) {
            try {
                this.selectedlokasi_masuk = this.lokasi_masuk[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasi_pulangChange(a) {
            try {
                this.selectedlokasi_pulang = this.lokasi_pulang[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/ProsesDataAbsensi/" + this.link);
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("DataAbsensi-Hapus", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.reload();
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async ambildatamaster() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("LokasiAbsensi-Data?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi_pulang = [];
                        this.lokasi_pulang = [];
                        this.datalokasi_pulang = Response.data.content.data;
                        this.datalokasi_pulang.forEach((item) => {
                            this.lokasi_pulang.push({
                                label: item.nama,
                                code: this.datalokasi_pulang.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi_pulang.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });


                        this.datalokasi_masuk = [];
                        this.lokasi_masuk = [];
                        this.datalokasi_masuk = Response.data.content.data;
                        this.datalokasi_masuk.forEach((item) => {
                            this.lokasi_masuk.push({
                                label: item.nama,
                                code: this.datalokasi_masuk.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi_masuk.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("DataAbsensi-DetailAbsen?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.id_user + "&bulan=" + this.bulan + "&tahun=" + this.tahun).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.tulisnama = '';
                    this.tulisjabatan = '';
                    this.tulisbulan = '';
                    this.tulistahun = '';
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.tulisnama = Response.data.content.nama;
                        this.tulisjabatan = Response.data.content.jabatan;
                        this.tulisbulan = Response.data.content.bulan;
                        this.tulistahun = Response.data.content.tahun;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildatamaster();
        //alert(this.secretencData);
        var kode = this.secretencData.split("|");
        this.bulan = kode[0];
        this.tahun = kode[1];
        this.id_user = kode[2];
        this.link = encodeURIComponent(CryptoJS.AES.encrypt(this.bulan.toString() + '|' + this.tahun.toString() + '|' + this.id_user.toString(), 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
        this.ambildata();
    }
}
</script>
<style></style>